import { useState, useEffect, useRef } from 'react';

// Add initialInviteCode prop for auto-filling
const ReferralPromptModal = ({ open, onSubmit, registering, registerError, initialInviteCode, referrerAddress }) => {
  const [inviteCode, setInviteCode] = useState(initialInviteCode || '');
  const [rememberChoice, setRememberChoice] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
    if (open && initialInviteCode && initialInviteCode !== inviteCode) {
      setInviteCode(initialInviteCode);
    }
  }, [open, initialInviteCode, inviteCode]);

  // eslint-disable-next-line
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-[3px] p-1 animate-fadeInModal">
      <style>{`
        @keyframes fadeInModal {
          from { opacity: 0; transform: scale(0.97); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
      <div
        className="w-full max-w-xs sm:max-w-sm bg-gradient-to-br from-gray-900 to-gray-800 border border-gray-700 rounded-xl shadow-xl flex flex-col items-center gap-2 relative px-2 py-4 sm:p-5"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-cyan-200 dark:bg-cyan-800 mb-1">
          <span className="text-xl sm:text-2xl select-none text-cyan-800 dark:text-cyan-100">🐬</span>
        </div>
        <h2 className="text-sm sm:text-base font-bold mb-0.5 text-center text-cyan-700 dark:text-cyan-300 tracking-wide">Referral Code</h2>
        <p className="text-cyan-600 dark:text-cyan-100 text-center text-xs sm:text-xs mb-1 sm:mb-2 font-normal leading-tight">Enter a code to join a team and unlock rewards. If you have no code, you can skip.</p>
        {referrerAddress && (
          <div className="w-full bg-cyan-100 dark:bg-cyan-900 border border-cyan-300 dark:border-cyan-700 rounded-lg p-1.5 mb-1 flex flex-col items-center">
            <span className="text-xs text-cyan-700 dark:text-cyan-300 font-semibold">Referrer Detected</span>
            <span className="text-xs text-cyan-600 dark:text-cyan-100 break-all">{referrerAddress}</span>
          </div>
        )}
        {registerError && (
          <div className="text-red-600 text-center font-semibold mb-1 animate-fadeInModal text-xs">
            {registerError}
          </div>
        )}
        <form
          onSubmit={e => {
            e.preventDefault();
            if (!registering) onSubmit({ inviteCode: inviteCode.trim(), rememberChoice });
          }}
          className="w-full flex flex-col gap-1 sm:gap-2"
        >
          <input
            ref={inputRef}
            className="rounded-md border border-cyan-300 dark:border-cyan-700 bg-gradient-to-br from-gray-900 to-gray-800 px-2 py-1.5 text-xs sm:text-sm text-cyan-700 dark:text-cyan-300 placeholder-cyan-600 dark:placeholder-cyan-100 focus:outline-none focus:ring-2 focus:ring-cyan-400 transition-all"
            placeholder="Referral code (optional)"
            value={inviteCode}
            onChange={e => setInviteCode(e.target.value)}
            disabled={registering}
            autoFocus
          />
          <div className="flex items-center gap-2 mb-2 mt-1">
            <input
              type="checkbox"
              id="remember-choice"
              checked={rememberChoice}
              onChange={e => {
                setRememberChoice(e.target.checked);
                console.log('[ReferralPromptModal] Remember this choice:', e.target.checked);
              }}
              disabled={registering}
              style={{ accentColor: '#0891b2' }}
            />
            <label htmlFor="remember-choice" className="text-xs text-cyan-700 dark:text-cyan-300 select-none cursor-pointer">
              Remember this choice
            </label>
          </div>
          <div className="flex flex-row gap-1 justify-center">
            <button
              type="submit"
              className="px-3 py-1 rounded-md bg-cyan-600 text-cyan-50 dark:text-cyan-100 text-xs font-semibold shadow hover:bg-cyan-700 transition-all disabled:opacity-60"
              disabled={registering}
            >
              {registering ? 'Registering...' : 'Continue'}
            </button>
            <button
              type="button"
              className="px-3 py-1 rounded-md bg-gray-100 dark:bg-zinc-800 text-cyan-700 dark:text-cyan-300 text-xs font-semibold border border-gray-200 dark:border-zinc-700 hover:bg-gray-200 dark:hover:bg-zinc-700 transition-all"
              onClick={() => onSubmit({ skip: true, rememberChoice })}
              disabled={registering}
            >
              Skip
            </button>
          </div>
        </form>
      </div>
    </div>

  );
}

export default ReferralPromptModal;
